<template>
  <YFooter type="complete" />
</template>

<script>
import { YFooter } from '@quero/yeti'

export default {
  name: 'TheFooter',
  components: {
    YFooter,
  },
}
</script>
